import React from 'react';

export default ({ addClass }) => <div className={`loader ${addClass}`}>Loading...</div>;
